<script setup lang="ts">
import { useIsSp } from '@mp/hooks'

const { isNotSp } = useIsSp()
</script>

<template>
  <section v-if="!isNotSp" class="bg-white p-4 rounded-lg text-sm">
    <div class="flex items-center cursor-default">
      <el-popover placement="top" :width="200">
        <template #reference>
          <img src="/qr-1.jpeg" class="qr-container" alt="">
        </template>
        <img src="/qr-1.jpeg" class="block w-full" alt="">
      </el-popover>

      <div class="flex-1">
        <h3 class="text-n-800">
          盛意旺官方公众号
        </h3>
        <p class="text-n-90 mt-2 mb-0">
          微信扫码关注，了解官方动态和行业资讯，可联系在线客服获得帮助
        </p>
      </div>
    </div>
    <div class="flex items-center cursor-default mt-4">
      <el-popover placement="top" :width="200">
        <template #reference>
          <img src="/download.png" class="qr-container" alt="">
        </template>
        <img src="/download.png" class="block w-full" alt="">
      </el-popover>

      <div class="flex-1">
        <h3 class="text-n-800">
          盛意旺APP下载
        </h3>
        <p class="text-n-90 mt-2 mb-0">
          扫描左侧二维码立即下载盛意旺APP
          随时随地掌握经营状况
        </p>
      </div>
    </div>
  </section>
</template>

<style scoped>
.qr-container {
  @apply border border-solid border-n-40 w-[88px] h-[88px] block bg-blueGraym mr-4;
}
</style>
